import MedicationFormCard from "./MedicationFormCard";

export default function MedicationFormsSection({
  styles,
  forms,
  activeTab,
  activePreviewId,
  setActivePreviewId,
  removeForm,
  handleInputChange,
  fetchDrugInfoForPreview,
  prescriptionId,
  navigationState,
  scriptNumber,
  isFromDispensaryMenu,
  pharmacyInfo,
  user,
  drugInfo,
  effectiveShowRepeat,
  repeatData,
  repeatNumberFromNav,
}) {
  return (
    <>
      <div className={styles.formsContainer}>
        {forms.map((form, index) => {
          const isTracerMode = activeTab === "Tracer Label" && index === 0;

          return (
            <div key={form.id}>
              <div
                className={
                  activeTab === "Item Label" || (activeTab === "Tracer Label" && index === 0)
                    ? isTracerMode
                      ? styles.tracerModeContainer
                      : ""
                    : styles.hiddenInTracerMode
                }
              >
                <div className={isTracerMode ? styles.tracerModeFlex : ""}>
                  <MedicationFormCard
                    form={form}
                    index={isTracerMode ? 0 : index}
                    total={isTracerMode ? 1 : forms.length}
                    onRemove={removeForm}
                    onFieldChange={handleInputChange}
                    onTogglePreview={(id) =>
                      setActivePreviewId(activePreviewId === id ? null : id)
                    }
                    onFetchDrugInfo={fetchDrugInfoForPreview}
                    isPreviewActive={
                      isTracerMode ? false : activePreviewId === form.id
                    }
                    prescriptionId={prescriptionId}
                    isDrug={form.isDrug}
                    initialMedications={navigationState?.medications || null}
                    scriptNumber={scriptNumber}
                    isFromDispensaryMenu={isFromDispensaryMenu}
                    pharmacyInfo={pharmacyInfo}
                    user={user}
                    drugInfo={drugInfo}
                    showRepeat={effectiveShowRepeat}
                    repeatData={repeatData}
                    repeatNumber={repeatNumberFromNav}
                  />
                </div>

                {isTracerMode && null}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
